import { FetchTypeWiseCountPOBSummary } from "../../../domain/useages/daily-pob-report/fetch-type-wise-count-pob-summary";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpGetClient } from "../../protocols/http/http-get-client";

export class RemoteFetchTypeWiseCountPOBSummary
  implements FetchTypeWiseCountPOBSummary
{
  constructor(
    private readonly url: string,
    private readonly httpGetClient: HttpGetClient
  ) {}

  async fetch(
    summaryParams: FetchTypeWiseCountPOBSummary.Params
  ): Promise<any> {
    const httpResponse = await this.httpGetClient.get({
      url: this.url,
      query: summaryParams,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      return httpResponse.data;
    } else {
      throw new Error("Failed to fetch count POB data summary");
    }
  }
}
